export default __webpack_public_path__ + "b723585a8050a104858f755971d5b93b.png";